exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loginLandingButton {\n    background: #FFFFFF;\n    box-shadow: 0 2px 11px 0 rgba(0,0,0,0.25);\n    margin-bottom: 1em;\n    color: #000000;\n    text-decoration: none;\n    padding: 1em;\n    display: flex;\n    border-radius: 8px;\n    align-items: center;\n}\n.loginLandingButton img {\n    margin-right: 1.1875em;\n}\n", ""]);

// exports
